<template>
    <div class="float-start">
        <p class="mb-1">
            {{ $t("supplierDetail.concurrency.table.data.tenders", number) }}<br>
            <span class="concurrency_price" v-if="false">{{ $filters.price(price_number) }}</span>
        </p>
        <ConcurrencyCircles :color="color" :number="number" />
    </div>
</template>

<script>
import ConcurrencyCircles from '@/components/ConcurrencyCircles.vue';
export default {
    name: "conccurrency-cell",
    components: {
        ConcurrencyCircles
    },
    props: {
        number: { required: true, type: Number },
        total: { required: true, type: Number },
        price_number: { required: true, type: Number },
        color: { required: true, type: String }
    },
}
</script>

<style lang="scss">
.concurrency_price {
    color: #00000099;
}
</style>